import React from "react";
import { useHistory } from "react-router-dom";
import CatalogItems from "../catalog-items/catalog-items";
import { useQuery } from "@apollo/client";
import { GET_COLLECTIONS } from "../../../queries/queries";
import CatalogItemsFiltered from "../catalog-items-filtered/catalog-items-filtered.component";
import NoResultsPage from "../../common/no -results-page/no-results-page.component";
import Loader from "../../common/loader/loader.component";
import { useTranslation } from "react-i18next";

function CatalogItemsContainer({
  onSeeAllClicked,
  collectionId,
  facetValueIds,
  items,
}) {
  const { t } = useTranslation();
  const history = useHistory();

  const showItem = (x) => {
    history.push(`/item/${x}`);
  };
  const { loading, error, data } = useQuery(GET_COLLECTIONS);

  if (loading) return <Loader color={"#B73232"} size={70} />;
  if (error) return `Error! ${error.message}`;

  const onSeeAll = (col) => {
    onSeeAllClicked(col);
  };

  if (items.length === 0) {
    return (
      <NoResultsPage
        title={t("catalog.No matching products")}
        descriprion={t("catalog.Try changing filters")}
      />
    );
  }

  let collectionsToDisplay = [];

  if (data) {
    collectionsToDisplay = data.collections.items
      .filter((c) => {
        return items.some((i) => i.collectionIds.includes(c.id));
      })
      .filter((collection) => collection?.parent?.slug === "categories");
  }

  return (
    <div>
      {facetValueIds.length || collectionId !== null ? (
        <CatalogItemsFiltered
          collectionId={collectionId}
          facetValueIds={facetValueIds}
          items={items}
        />
      ) : (
        collectionsToDisplay?.map((collection, i) => {
          return (
            <React.Fragment key={collection.id}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h3 className="h3">{collection.name}</h3>
                <span
                  className="h6-medium"
                  style={{ color: "#80BB34", cursor: "pointer" }}
                  onClick={() => {
                    onSeeAll(collection);
                  }}
                >
                  {t("catalog.See All")}
                </span>
              </div>
              <CatalogItems
                collectionId={collection.id}
                showItem={showItem}
                key={i}
                items={items}
              />
            </React.Fragment>
          );
        })
      )}
    </div>
  );
}

export default CatalogItemsContainer;
